import React, { useCallback, useState } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import ShowAllToggle, { rowActive } from "./ShowAllToggle";
import { fitActionColumn } from "../../Utils/actionColumn";
const CustomTable = ({
  columns,
  data,
  search,
  type,
  isAllActiveFilterNotReq 
}) => {
  const [searchData, setSeacrhData] = useState("");
  // Lists open with active rows only; "Show all" adds the inactive ones.
  const [showAll, setShowAll] = useState(false);
  // Offer the switch only when the rows carry a status to filter on.
  const canFilter = isAllActiveFilterNotReq !== true && (data || []).some((row) => rowActive(row) !== null);
  // inactive rows out of view while the list shows active ones only
  const hiddenCount = canFilter && !showAll ? data.filter((row) => rowActive(row) === false).length : 0;
  // const onSearch = (value, sortByKey="asc" , allData , isAlldata) => {
  // //  setSeacrhData(value);
  //   debugger
  
  //   const searchRes = allData.filter((o) =>
  //     !isAlldata? o.status_data ==1 &&
  //     Object.keys(o).some((k) =>
  //       String(o[k]).toLowerCase().includes(value.toLowerCase())
  //     ) :Object.keys(o).some((k) =>
  //       String(o[k]).toLowerCase().includes(value.toLowerCase()))
  //   );
  //   // setFilterData(searchRes);
  //   const sortedData = searchRes.sort((a, b) => {
  //     const aValue = a[sortByKey]?.toLowerCase();
  //     const bValue = b[sortByKey]?.toLowerCase();

  //     if (aValue < bValue) return -1;
  //     if (aValue > bValue) return 1;
  //     return 0;
  //   });
  //   //setFilterData(sortedData);
  //   return sortedData
  // };
  
  const isDataInRow = (rowData)=>{
      //if (!value) return allData; // If no value, return all data immediately
      const lowerCaseValue = searchData.toLowerCase();
    return Object.keys(rowData).some((k) =>
      String(rowData[k]).toLowerCase().includes(lowerCaseValue)
    )
  }

  const onSearch = useCallback((value, sortByKey = "asc", allData, isActiveDataOnly) => {
    if(!isActiveDataOnly && !searchData ){
      return allData
    }
    let BothFilters =  isActiveDataOnly && searchData 
    // a row with no status of its own stays in the active list
    const searchRes = allData.filter((o) =>
      BothFilters ? rowActive(o) !== false && isDataInRow(o)
           :isActiveDataOnly ? rowActive(o) !== false : isDataInRow(o)
    );
    const sortedData = searchRes.sort((a, b) => {
      const aValue = String(a[sortByKey] || "").toLowerCase();
      const bValue = String(b[sortByKey] || "").toLowerCase();
  
      return aValue.localeCompare(bValue);
    });
  
    return sortedData;
  }, [data, searchData , showAll]);

  const customStyles = {
    table: { style: { tableLayout: "fixed" } },
    headRow: { style: { backgroundColor: "#f1f1f1", color: "#333", fontSize: "13px", minHeight: "36px" } },
    headCells: { style: { paddingLeft: "8px", paddingRight: "8px", paddingTop: "6px", paddingBottom: "6px", fontWeight: "bold", fontSize: "13px" } },
    rows: { style: { minHeight: "32px", paddingTop: "0px", paddingBottom: "0px", fontSize: "13px", backgroundColor: "#fff", "&:nth-child(odd)": { backgroundColor: "#f9f9f9" } } },
    cells: { style: { paddingTop: "4px", paddingBottom: "4px", paddingLeft: "8px", paddingRight: "8px" } },
    pagination: { style: { minHeight: "40px", fontSize: "13px" } },
  };

  return (
    <>
     
        <div className="searc-bar">
          <div className="row">
          {search === false? "": <div className={ "col-md-6"}>
              <input
                type="search"
                className="form-control  float-end"
                placeholder="Search here..."
                value={searchData}
                onChange={(e) => setSeacrhData(e.target.value)}
              />
            </div>
            }
            {/* {searchData &&
        <div onClick={()=>setSeacrhData('')}><i class="fa-solid fa-xmark"></i></div>
       } */}
            
            { canFilter ? <div className={search === false?"col-md-12 text-end":"col-md-6 text-end"}>
                <ShowAllToggle checked={showAll} onChange={setShowAll} hidden={hiddenCount} />
              </div> : ""}
            
          </div>
        </div>
      
      <DataTable
        noHeader
        columns={fitActionColumn(columns, data)}
        data={data?.length > 0  ?onSearch(searchData,"asc" , data , canFilter && !showAll):data}
        defaultSortField="id"
        defaultSortAsc={true}
        pagination
        paginationPerPage={20}
        sortMode="multiple"
        highlightOnHover
        customStyles={customStyles}
      />
    </>
  );
};

export default CustomTable;
